import React from 'react';

/**
 * CoinsIcon is a React functional component that renders an SVG icon of a coin.
 * The SVG has a width and height of 24, and consists of a single path with a stroke color of #1C3344.
 * The icon is designed to be used in the context of a button or link.
 */
const CoinsIcon: React.FC = () => (
  <svg
    width="98"
    height="100"
    viewBox="0 0 98 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.29 98H73.7C74.91 98 76.08 97.57 77.03 96.83C88 88.28 94.81 74.65 93.91 59.47C92.59 37.06 74.19 19.05 51.76 18.17C26.66 17.18 6 37.24 6 62.13C6 76.24 12.64 88.78 22.97 96.83C23.92 97.57 25.09 98 26.3 98H26.29Z"
      fill="#9FD8C4"
      fill-opacity="0.5"
    />
    <path
      d="M50 18.13C34.98 18.13 21.72 25.66 13.78 37.15C12.15 41.66 11.26 46.53 11.26 51.61C11.26 75.12 30.32 94.18 53.83 94.18C72.17 94.18 87.8 82.58 93.79 66.31C93.92 64.93 94.01 63.54 94.01 62.13C94.01 37.83 74.31 18.13 50.01 18.13H50Z"
      fill="#D9EEE5"
    />
    <path
      d="M13.3 37.69C12.18 36.93 12.17 36.92 12.93 35.74C18.51 27.12 26.12 21.02 35.79 17.54C36.6 17.25 37.09 16.85 37.41 16.04C37.96 14.63 38.68 13.28 39.25 11.87C39.88 10.32 40.59 8.86 42.13 8H45.12C45.4 8.36 45.84 8.42 46.22 8.59C52.22 11.28 58.23 13.95 64.22 16.67C64.84 16.95 65.04 16.84 65.27 16.25C65.67 15.22 66.17 14.22 66.62 13.21C66.96 12.45 67.39 11.76 68.03 11.22C69.67 9.81 72.08 9.66 73.9 10.86C75.65 12.01 76.48 14.34 75.75 16.36C75.28 17.68 74.69 18.96 74.08 20.22C73.78 20.83 73.92 21.02 74.5 21.28C80.59 23.98 86.67 26.72 92.75 29.45C95.33 30.61 96.12 32.68 94.97 35.28C94.18 37.07 93.4 38.87 92.55 40.63C92.21 41.34 92.18 41.94 92.51 42.68C93.77 45.53 94.61 48.5 95.21 51.56C95.44 52.72 95.43 53.92 95.86 55.03V64.89C95.5 65.57 95.58 66.34 95.46 67.07C94.32 73.74 91.94 79.91 88.06 85.48C87.2 86.71 87.21 86.72 86.01 86.01C85.08 85.16 85.07 85.15 85.81 84.09C87.74 81.33 89.32 78.37 90.52 75.22C91.87 71.66 92.84 68 93.07 64.18C93.11 64.01 93.18 63.84 93.19 63.67C93.38 61.03 93.46 58.39 93.15 55.76C92.83 53 92.42 50.25 91.46 47.62C91.13 46.07 90.46 44.63 89.9 43.16C89.7 42.64 89.39 42.37 88.9 42.16C83.96 39.96 79.02 37.75 74.09 35.53C62.4 30.3 50.71 25.06 39.02 19.83C38.67 19.67 38.34 19.41 37.87 19.58C36.24 20.15 34.61 20.69 33.09 21.51C32.98 21.54 32.86 21.55 32.75 21.6C25.47 25.16 19.56 30.28 15.18 37.12C14.45 38.26 14.46 38.27 13.3 37.67V37.69ZM43.75 10.47C42.97 10.52 42.58 10.92 42.33 11.49C41.59 13.15 40.88 14.81 40.09 16.45C39.79 17.08 39.85 17.36 40.54 17.66C46.05 20.09 51.55 22.56 57.05 25.03C67.81 29.85 78.57 34.66 89.32 39.49C89.9 39.75 90.16 39.71 90.41 39.09C91.1 37.42 91.88 35.78 92.61 34.12C93.11 32.98 92.89 32.4 91.73 31.88C76.01 24.84 60.28 17.8 44.56 10.77C44.27 10.64 43.96 10.55 43.75 10.48V10.47ZM73.38 15.11C73.38 13.92 72.73 13.01 71.8 12.77C70.81 12.51 69.73 12.94 69.27 13.88C68.66 15.11 68.14 16.38 67.55 17.63C67.34 18.07 67.58 18.18 67.9 18.33C68.89 18.76 69.89 19.18 70.86 19.66C71.3 19.88 71.45 19.75 71.62 19.34C72.11 18.18 72.65 17.04 73.15 15.89C73.28 15.6 73.33 15.28 73.38 15.12V15.11Z"
      fill="#22E517"
    />
    <path
      d="M76.5 93.73C75.3 94.86 74.11 95.52 72.45 95.39C70.25 95.23 68.03 95.35 65.62 95.35C66.74 94.34 67.63 93.36 68.26 92.18C68.37 91.97 68.55 91.93 68.78 91.98C71.33 92.56 73.89 93.14 76.5 93.73Z"
      fill="#9FD8C4"
      fill-opacity="0.5"
    />
    <path
      d="M33.58 87.75C32.9 87.8 32.27 87.68 31.77 87.16C32.36 87.39 33.21 86.85 33.58 87.75Z"
      fill="#D9EEE5"
    />
    <path
      d="M29.29 86.22C29.16 86.35 29.16 86.24 29.15 86.14C29.21 86.14 29.25 86.17 29.29 86.22Z"
      fill="#D9EEE5"
    />
    <path
      d="M33.7 87.96C33.65 87.88 33.6 87.81 33.55 87.73C33.6 87.81 33.65 87.89 33.7 87.96Z"
      fill="#D9EEE5"
    />
    <path
      d="M43.75 10.47C43.96 10.54 44.27 10.63 44.56 10.76C60.28 17.79 76.01 24.83 91.73 31.87C92.89 32.39 93.11 32.97 92.61 34.11C91.88 35.77 91.1 37.41 90.41 39.08C90.15 39.71 89.89 39.74 89.32 39.48C78.57 34.65 67.81 29.83 57.05 25.02C51.55 22.56 46.06 20.08 40.54 17.65C39.85 17.35 39.79 17.07 40.09 16.44C40.87 14.81 41.59 13.14 42.33 11.48C42.59 10.9 42.98 10.51 43.75 10.46V10.47ZM54.96 18.6C54.96 18.41 54.84 18.3 54.67 18.22C54.35 18.07 54.04 17.91 53.72 17.76C52.98 17.41 52.47 17.6 52.17 18.34C51.82 19.22 52.08 19.86 52.95 20.27C53.19 20.38 53.44 20.46 53.68 20.57C53.82 20.63 54 20.69 54.07 20.53C54.38 19.9 54.66 19.26 54.95 18.6H54.96ZM81.24 30.51C81.28 30.02 80.95 29.91 80.69 29.85C80.08 29.71 79.63 29.09 78.93 29.29C78.85 29.31 78.8 29.47 78.75 29.58C78.55 30.03 78.35 30.49 78.15 30.94C77.98 31.31 78.09 31.61 78.48 31.69C79.16 31.84 79.76 32.73 80.42 32.22C80.89 31.86 81 31.04 81.24 30.51ZM68.16 24.47C68.13 24.38 68.12 24.33 68.1 24.28C68.01 24.12 66.14 23.31 65.95 23.34C65.75 23.38 65.67 23.53 65.58 23.68C64.59 25.29 64.65 25.48 66.33 26.25C66.49 26.32 66.65 26.42 66.81 26.45C66.94 26.48 67.17 26.47 67.21 26.4C67.55 25.76 67.85 25.1 68.16 24.46V24.47ZM87.95 33.28C87.46 32.67 86.7 32.65 86.13 32.29C85.94 32.17 85.72 32.03 85.51 32.28C85.47 32.32 85.45 32.38 85.42 32.43C84.33 33.99 84.46 34.44 86.21 35.14C86.34 35.19 86.48 35.26 86.62 35.29C86.77 35.33 86.94 35.32 87.01 35.18C87.33 34.56 87.63 33.93 87.95 33.27V33.28ZM61.47 21.74C61.53 21.38 61.43 21.29 61.31 21.19C59.91 20 59.1 20.21 58.5 21.91C58.45 22.05 58.39 22.18 58.36 22.32C58.32 22.5 58.36 22.67 58.55 22.76C59.13 23.03 59.71 23.3 60.29 23.57C60.44 23.64 60.58 23.62 60.65 23.46C60.95 22.83 61.25 22.2 61.46 21.74H61.47ZM74.69 27.42C74.68 27.35 74.67 27.3 74.65 27.25C74.53 26.99 72.68 26.22 72.44 26.34C72.35 26.39 72.27 26.49 72.22 26.59C71.91 27.18 71.44 27.8 71.51 28.43C71.57 28.89 72.39 28.86 72.82 29.15C72.99 29.26 73.18 29.33 73.37 29.42C73.51 29.48 73.68 29.53 73.77 29.39C74.16 28.78 74.46 28.11 74.69 27.43V27.42ZM46.94 17.59C47.32 17.68 47.46 17.62 47.52 17.48C47.79 16.9 48.05 16.31 48.29 15.72C48.36 15.54 48.22 15.4 48.08 15.28C46.72 14.15 45.95 14.34 45.33 15.95C45.28 16.09 45.23 16.22 45.18 16.36C45.12 16.54 45.13 16.71 45.32 16.81C45.92 17.11 46.52 17.39 46.93 17.59H46.94Z"
      fill="#B6F829"
    />
    <path
      d="M36.16 22.97C35.2 22.36 34.1 22.04 33.1 21.52C34.62 20.7 36.26 20.16 37.88 19.59C38.35 19.43 38.68 19.69 39.03 19.84C50.72 25.07 62.41 30.3 74.1 35.54C79.04 37.75 83.97 39.97 88.91 42.17C89.39 42.39 89.71 42.66 89.91 43.17C90.47 44.64 91.14 46.07 91.47 47.63C90.44 47.28 89.52 46.67 88.46 46.4C87.95 45.57 87.25 45.27 86.36 45.49C85.31 44.72 84.07 44.36 82.91 43.82C79.75 42.36 76.56 40.97 73.38 39.55C68.57 37.41 63.76 35.27 58.95 33.12C55.34 31.51 51.75 29.86 48.14 28.26C44.8 26.78 41.51 25.18 38.11 23.84C37.69 23.02 37.04 22.73 36.16 22.97Z"
      fill="#9FD8C4"
      fill-opacity="0.5"
    />
    <path
      d="M73.38 15.11C73.33 15.27 73.28 15.59 73.15 15.88C72.65 17.03 72.11 18.17 71.62 19.33C71.45 19.74 71.3 19.87 70.86 19.65C69.89 19.17 68.9 18.75 67.9 18.32C67.57 18.18 67.34 18.06 67.55 17.62C68.14 16.38 68.66 15.11 69.27 13.87C69.73 12.94 70.81 12.51 71.8 12.76C72.73 13 73.38 13.91 73.38 15.1V15.11Z"
      fill="#22E517"
    />
    <path
      d="M86.36 45.49C87.25 45.27 87.95 45.58 88.46 46.4C88.91 48.36 89.62 50.25 89.98 52.23C90.28 53.89 90.57 55.56 90.58 57.25C90.58 57.95 90.81 58.63 90.76 59.34C90.73 59.79 90.59 59.93 90.14 59.96C88.18 60.07 88.01 59.99 87.95 58.05C87.84 54.28 87.11 50.64 85.73 47.14C85.39 46.28 85.5 45.79 86.35 45.47L86.36 45.49Z"
      fill="#FDFDFD"
    />
    <path
      d="M36.16 22.97C37.04 22.73 37.69 23.02 38.11 23.84C38.15 23.98 38.15 24.13 38.22 24.26C38.49 24.79 38.33 25.05 37.77 25.26C35.05 26.28 32.5 27.63 30.09 29.26C28.56 30.3 28.57 30.29 27.5 28.83C27.14 28.34 27.21 28.06 27.71 27.7C30.26 25.86 32.97 24.33 35.87 23.14C35.97 23.1 36.06 23.02 36.16 22.96V22.97Z"
      fill="#FDFDFD"
    />
    <path
      d="M26.46 31.92C26.31 32.34 25.89 32.59 25.57 32.92C24.98 33.53 24.51 33.54 23.9 32.85C22.83 31.65 22.77 31.68 24.16 30.65C24.43 30.45 24.57 29.94 25.07 30.13C25.29 30.21 26.47 31.7 26.47 31.93L26.46 31.92Z"
      fill="#FDFDFD"
    />
    <path
      d="M21.08 33.91C21.26 33.91 22.89 35.28 22.89 35.42C22.91 35.79 22.57 35.96 22.39 36.21C21.47 37.52 21.46 37.51 20.23 36.55C19.26 35.8 19.25 35.79 20.14 34.86C20.45 34.54 20.55 33.99 21.07 33.91H21.08Z"
      fill="#FDFDFD"
    />
    <path
      d="M54.96 18.6C54.66 19.25 54.38 19.9 54.07 20.53C54 20.68 53.82 20.63 53.68 20.57C53.44 20.47 53.19 20.38 52.95 20.27C52.08 19.86 51.82 19.22 52.17 18.34C52.46 17.6 52.98 17.41 53.72 17.76C54.04 17.91 54.35 18.07 54.67 18.22C54.84 18.3 54.96 18.41 54.96 18.6Z"
      fill="#FDFDFD"
    />
    <path
      d="M81.24 30.51C81 31.05 80.89 31.86 80.42 32.22C79.76 32.73 79.15 31.84 78.48 31.69C78.1 31.61 77.99 31.31 78.15 30.94C78.35 30.49 78.55 30.03 78.75 29.58C78.8 29.47 78.85 29.31 78.93 29.29C79.63 29.09 80.08 29.71 80.69 29.85C80.95 29.91 81.28 30.02 81.24 30.51Z"
      fill="#FDFDFD"
    />
    <path
      d="M68.16 24.47C67.85 25.1 67.55 25.76 67.21 26.41C67.17 26.48 66.94 26.49 66.81 26.46C66.64 26.43 66.49 26.33 66.33 26.26C64.65 25.49 64.6 25.3 65.58 23.69C65.67 23.54 65.75 23.38 65.95 23.35C66.14 23.32 68.02 24.13 68.1 24.29C68.13 24.34 68.14 24.4 68.16 24.48V24.47Z"
      fill="#FDFDFD"
    />
    <path
      d="M87.95 33.28C87.63 33.94 87.33 34.57 87.01 35.19C86.94 35.33 86.76 35.33 86.62 35.3C86.48 35.26 86.35 35.2 86.21 35.15C84.47 34.44 84.33 33.99 85.42 32.44C85.45 32.39 85.47 32.33 85.51 32.29C85.72 32.04 85.95 32.19 86.13 32.3C86.7 32.65 87.46 32.67 87.95 33.29V33.28Z"
      fill="#FDFDFD"
    />
    <path
      d="M61.47 21.74C61.25 22.2 60.96 22.83 60.66 23.46C60.58 23.62 60.45 23.64 60.3 23.57C59.72 23.3 59.14 23.03 58.56 22.76C58.37 22.67 58.33 22.51 58.37 22.32C58.4 22.18 58.46 22.04 58.51 21.91C59.11 20.21 59.92 20 61.32 21.19C61.44 21.29 61.54 21.38 61.48 21.74H61.47Z"
      fill="#FDFDFD"
    />
    <path
      d="M74.69 27.42C74.46 28.11 74.17 28.77 73.77 29.38C73.68 29.52 73.51 29.47 73.37 29.41C73.18 29.33 72.99 29.25 72.82 29.14C72.39 28.86 71.57 28.88 71.51 28.42C71.44 27.8 71.91 27.18 72.22 26.58C72.27 26.48 72.35 26.38 72.44 26.33C72.67 26.21 74.53 26.98 74.65 27.24C74.67 27.29 74.68 27.35 74.69 27.41V27.42Z"
      fill="#FDFDFD"
    />
    <path
      d="M46.94 17.59C46.53 17.4 45.93 17.11 45.33 16.81C45.14 16.72 45.12 16.55 45.19 16.36C45.24 16.22 45.29 16.09 45.34 15.95C45.95 14.33 46.72 14.14 48.09 15.28C48.23 15.4 48.37 15.54 48.3 15.72C48.06 16.31 47.8 16.9 47.53 17.48C47.47 17.62 47.33 17.68 46.95 17.59H46.94Z"
      fill="#FDFDFD"
    />
    <path
      d="M48.6 85.19C48.23 85.42 47.95 85.48 47.57 85.35C47.89 85.09 48.2 85.22 48.6 85.19Z"
      fill="#2C2C2C"
    />
    <path
      d="M68.24 90.39C66.75 93.5 58 92.4 48.71 87.93C39.41 83.46 33.09 77.33 34.59 74.22L36.95 69.31L70.61 85.49L68.25 90.4L68.24 90.39Z"
      fill="#11C949"
    />
    <path
      d="M36.77 79.71L40.87 71.19L39.06 70.32L35.39 77.95C35.76 78.52 36.23 79.1 36.78 79.7L36.77 79.71Z"
      fill="#20E015"
    />
    <path
      d="M40.13 82.73L44.77 73.07L42.96 72.2L38.53 81.42C39.02 81.86 39.56 82.3 40.13 82.73Z"
      fill="#20E015"
    />
    <path
      d="M43.75 85.22L48.69 74.95L46.88 74.08L42.06 84.12C42.61 84.49 43.17 84.86 43.76 85.22H43.75Z"
      fill="#20E015"
    />
    <path
      d="M47.54 87.35L52.6 76.83L50.79 75.96L45.77 86.4C46.35 86.72 46.94 87.04 47.55 87.35H47.54Z"
      fill="#20E015"
    />
    <path
      d="M51.48 89.16L56.5 78.7L54.69 77.83L49.63 88.36C50.25 88.65 50.86 88.91 51.48 89.16Z"
      fill="#20E015"
    />
    <path
      d="M55.56 90.66L60.4 80.58L58.59 79.71L53.64 90.01C54.29 90.25 54.93 90.47 55.56 90.66Z"
      fill="#20E015"
    />
    <path
      d="M59.85 91.75L64.32 82.46L62.51 81.59L57.84 91.31C58.54 91.48 59.21 91.63 59.86 91.76L59.85 91.75Z"
      fill="#20E015"
    />
    <path
      d="M64.49 92.13L68.23 84.34L66.42 83.47L62.28 92.09C63.08 92.16 63.82 92.17 64.49 92.13Z"
      fill="#20E015"
    />
    <path
      d="M70.77 85.13C72.33 81.89 66.06 75.64 56.76 71.17C47.47 66.7 38.67 65.71 37.11 68.95C35.55 72.19 41.82 78.44 51.12 82.91C60.41 87.38 69.21 88.37 70.77 85.13Z"
      fill="#B3F428"
    />
    <path
      d="M67.75 83.68C69.03 81.02 63.88 75.89 56.25 72.23C48.62 68.56 41.4 67.75 40.12 70.41C38.84 73.07 43.99 78.2 51.62 81.86C59.25 85.53 66.47 86.34 67.75 83.68Z"
      fill="#11C949"
    />
    <path
      d="M55.66 73.46C48.69 70.11 42.1 69.37 40.94 71.79C40.6 72.49 40.76 73.38 41.31 74.37C43.21 76.81 46.95 79.6 51.62 81.85C56.29 84.1 60.8 85.27 63.9 85.23C65.02 85.04 65.81 84.61 66.15 83.91C67.32 81.48 62.62 76.8 55.65 73.45L55.66 73.46Z"
      fill="#6AE50A"
    />
    <path
      d="M56.35 77.94C54.45 76.97 56.65 68.89 61.27 59.9C65.88 50.92 71.16 44.42 73.05 45.39L78.26 48.06L61.56 80.61L56.35 77.94Z"
      fill="#22E517"
    />
    <path
      d="M68.9 48.05L76.31 51.85L77.21 50.09L70.34 46.57C69.89 46.98 69.41 47.47 68.9 48.05Z"
      fill="#11C949"
    />
    <path
      d="M66.26 51.47L74.37 55.63L75.27 53.87L67.43 49.85C67.05 50.36 66.66 50.89 66.26 51.46V51.47Z"
      fill="#11C949"
    />
    <path
      d="M63.95 55.06L72.43 59.41L73.33 57.65L64.99 53.37C64.65 53.91 64.3 54.47 63.95 55.05V55.06Z"
      fill="#11C949"
    />
    <path
      d="M61.86 58.77L70.49 63.2L71.39 61.44L62.8 57.04C62.48 57.61 62.17 58.18 61.85 58.77H61.86Z"
      fill="#11C949"
    />
    <path
      d="M59.96 62.57L68.55 66.98L69.45 65.22L60.82 60.79C60.52 61.39 60.24 61.98 59.96 62.56V62.57Z"
      fill="#11C949"
    />
    <path
      d="M58.25 66.46L66.62 70.75L67.52 68.99L59.02 64.63C58.75 65.25 58.49 65.86 58.25 66.45V66.46Z"
      fill="#11C949"
    />
    <path
      d="M56.8 70.49L64.68 74.53L65.58 72.77L57.43 68.59C57.2 69.24 56.98 69.87 56.79 70.48L56.8 70.49Z"
      fill="#11C949"
    />
    <path
      d="M55.77 74.74L62.74 78.31L63.64 76.55L56.17 72.72C55.99 73.45 55.86 74.13 55.78 74.74H55.77Z"
      fill="#11C949"
    />
    <path
      d="M73.5 66.17C68.89 75.16 63.55 81.62 61.57 80.61C59.59 79.6 61.73 71.49 66.34 62.5C70.95 53.51 76.29 47.05 78.27 48.06C80.25 49.07 78.11 57.18 73.5 66.17Z"
      fill="#C1FE40"
    />
    <path
      d="M72.85 65.84C69.07 73.22 64.68 78.52 63.06 77.69C61.44 76.86 63.19 70.2 66.97 62.83C70.75 55.45 75.14 50.15 76.76 50.98C78.38 51.81 76.63 58.47 72.85 65.84Z"
      fill="#22E517"
    />
    <path
      d="M71.57 65.19C75.02 58.45 76.62 52.38 75.14 51.62C75.08 51.59 75 51.57 74.93 51.56C72.84 53.14 69.74 57.43 66.97 62.84C64.2 68.25 62.52 73.26 62.46 75.88C62.51 75.93 62.57 75.98 62.63 76.01C64.11 76.77 68.12 71.93 71.57 65.19Z"
      fill="#7AED20"
    />
    <path
      d="M74.94 73.55C76.16 73.55 77.09 74.44 77.11 75.65C77.13 76.85 76.21 77.78 74.99 77.81C73.82 77.83 72.85 76.86 72.86 75.67C72.86 74.5 73.79 73.56 74.94 73.55ZM74.94 76.37C75.41 76.37 75.67 76.1 75.68 75.68C75.68 75.26 75.42 74.98 74.97 74.99C74.56 74.99 74.31 75.23 74.29 75.65C74.27 76.1 74.52 76.33 74.94 76.38V76.37Z"
      fill="#11C949"
    />
    <path
      d="M18.94 62.55C20.16 62.55 21.09 63.44 21.11 64.65C21.13 65.85 20.21 66.78 18.99 66.81C17.82 66.83 16.85 65.86 16.86 64.67C16.86 63.5 17.79 62.56 18.94 62.55ZM18.94 65.37C19.41 65.37 19.67 65.1 19.68 64.68C19.68 64.26 19.42 63.98 18.97 63.99C18.56 63.99 18.31 64.23 18.29 64.65C18.27 65.1 18.52 65.33 18.94 65.38V65.37Z"
      fill="#11C949"
    />
    <path
      d="M66.27 38.77C66.34 39.18 66.19 39.48 65.89 39.75C65.48 40.11 65.12 40.52 64.73 40.9C64.42 41.2 64.02 41.21 63.74 40.94C63.46 40.67 63.46 40.25 63.74 39.95C64.18 39.49 64.64 39.05 65.09 38.6C65.33 38.36 65.62 38.37 65.93 38.43L66.27 38.77Z"
      fill="#11C949"
    />
    <path
      d="M65.43 42.65C65.68 42.9 65.93 43.13 66.17 43.39C66.42 43.67 66.43 44.03 66.21 44.29C66 44.54 65.59 44.62 65.32 44.38C64.76 43.87 64.22 43.33 63.7 42.77C63.45 42.5 63.52 42.1 63.76 41.88C64.02 41.65 64.39 41.66 64.69 41.92C64.71 41.94 64.73 41.96 64.75 41.98L65.43 42.66V42.65Z"
      fill="#11C949"
    />
    <path
      d="M62.02 39.24C62.27 39.49 62.52 39.72 62.76 39.98C63.03 40.28 63.04 40.64 62.79 40.9C62.55 41.16 62.15 41.21 61.87 40.95C61.34 40.46 60.83 39.95 60.34 39.42C60.06 39.12 60.11 38.72 60.39 38.47C60.66 38.24 61.01 38.26 61.31 38.53C61.33 38.55 61.35 38.57 61.37 38.59L62.02 39.24Z"
      fill="#11C949"
    />
    <path
      d="M62.1 43.53C61.86 43.77 61.63 44.01 61.38 44.24C61.09 44.5 60.73 44.49 60.46 44.24C60.19 43.98 60.13 43.59 60.39 43.32C60.86 42.81 61.36 42.31 61.87 41.84C62.15 41.58 62.54 41.63 62.79 41.9C63.05 42.17 63.06 42.53 62.81 42.82C62.79 42.84 62.78 42.86 62.76 42.88L62.1 43.54V43.53Z"
      fill="#11C949"
    />
    <path
      d="M25.57 67.36C25.96 67.64 26.08 68 26.06 68.47C26.02 69.09 26.06 69.72 26.05 70.35C26.05 70.84 25.73 71.18 25.28 71.18C24.84 71.18 24.49 70.85 24.48 70.37C24.46 69.64 24.48 68.91 24.48 68.18C24.48 67.79 24.73 67.56 25.02 67.37H25.57V67.36Z"
      fill="#11C949"
    />
    <path
      d="M28.04 71.18C28.44 71.18 28.84 71.17 29.24 71.18C29.67 71.2 29.97 71.48 30 71.87C30.03 72.25 29.77 72.64 29.35 72.66C28.48 72.7 27.6 72.7 26.73 72.66C26.32 72.64 26.04 72.26 26.06 71.89C26.08 71.49 26.4 71.2 26.85 71.17C26.88 71.17 26.91 71.17 26.94 71.17H28.04V71.18Z"
      fill="#11C949"
    />
    <path
      d="M22.51 71.18C22.91 71.18 23.31 71.17 23.7 71.18C24.16 71.2 24.46 71.48 24.47 71.9C24.49 72.31 24.21 72.67 23.76 72.68C22.93 72.71 22.11 72.71 21.28 72.68C20.81 72.66 20.52 72.3 20.55 71.87C20.58 71.46 20.88 71.2 21.35 71.17C21.38 71.17 21.41 71.17 21.44 71.17H22.5L22.51 71.18Z"
      fill="#11C949"
    />
    <path
      d="M26.05 74.6C26.05 74.99 26.06 75.37 26.05 75.76C26.03 76.2 25.73 76.49 25.3 76.5C24.87 76.51 24.51 76.24 24.49 75.81C24.46 75.01 24.46 74.21 24.49 73.41C24.51 72.98 24.86 72.7 25.29 72.71C25.72 72.71 26.01 73 26.05 73.44C26.05 73.47 26.05 73.5 26.05 73.53V74.6Z"
      fill="#11C949"
    />
    <path
      d="M28.1205 63.3763C33.0305 69.6663 43.6005 69.6263 51.7405 63.2963C59.8805 56.9663 62.4905 46.7363 57.5905 40.4563L54.1405 36.0463L24.6705 58.9563L28.1205 63.3663V63.3763Z"
      fill="#22E517"
    />
    <path
      d="M59.8505 50.4163L50.7005 38.6963L52.2905 37.4563L60.0405 47.3863C60.0805 48.3763 60.0105 49.3863 59.8505 50.4063V50.4163Z"
      fill="#11C949"
    />
    <path
      d="M58.2305 55.3963L47.2805 41.3663L48.8705 40.1263L59.1205 53.2563C58.8705 53.9663 58.5705 54.6863 58.2305 55.3863V55.3963Z"
      fill="#11C949"
    />
    <path
      d="M55.7705 59.2963L43.8505 44.0263L45.4405 42.7863L56.9905 57.5763C56.6205 58.1563 56.2105 58.7263 55.7705 59.2863V59.2963Z"
      fill="#11C949"
    />
    <path
      d="M52.7405 62.4563L40.4305 46.6963L42.0205 45.4563L54.2105 61.0663C53.7505 61.5463 53.2605 62.0063 52.7405 62.4563Z"
      fill="#11C949"
    />
    <path
      d="M49.2305 65.0063L37.0205 49.3663L38.6105 48.1263L50.9305 63.9063C50.3705 64.3063 49.8105 64.6663 49.2405 65.0063H49.2305Z"
      fill="#11C949"
    />
    <path
      d="M45.2005 66.8963L33.5905 52.0263L35.1805 50.7863L47.1305 66.1063C46.4905 66.4063 45.8405 66.6663 45.2005 66.8963Z"
      fill="#11C949"
    />
    <path
      d="M40.5305 67.9563L30.1705 54.6763L31.7605 53.4363L42.8005 67.5763C42.0405 67.7463 41.2805 67.8663 40.5405 67.9463L40.5305 67.9563Z"
      fill="#11C949"
    />
    <path
      d="M34.7405 67.5863L26.7505 57.3463L28.3405 56.1063L37.6505 68.0263C36.6505 67.9663 35.6805 67.8163 34.7505 67.5763L34.7405 67.5863Z"
      fill="#11C949"
    />
    <path
      d="M48.6705 59.3663C56.8105 53.0363 59.2605 42.5863 54.1405 36.0363C49.0205 29.4863 38.2805 29.2963 30.1405 35.6363C22.0005 41.9563 19.5605 52.4063 24.6705 58.9663C29.7905 65.5163 40.5305 65.7063 48.6705 59.3663Z"
      fill="#C1FE40"
    />
    <path
      d="M47.0105 57.2363C53.6905 52.0363 55.7005 43.4663 51.5005 38.0863C47.3005 32.7063 38.4805 32.5563 31.8105 37.7563C25.1305 42.9563 23.1205 51.5263 27.3105 56.9063C31.5105 62.2863 40.3305 62.4363 47.0005 57.2363H47.0105Z"
      fill="#22E517"
    />
    <path
      d="M47.0005 57.2363C53.1005 52.4963 54.9305 44.6663 51.1005 39.7563C47.2705 34.8463 39.2205 34.7063 33.1205 39.4563C27.0205 44.1963 25.1905 52.0263 29.0205 56.9363C32.8505 61.8463 40.9005 61.9863 47.0005 57.2363Z"
      fill="#7AED20"
    />
    <rect x="22" y="97" width="54" height="3" rx="1.5" fill="#9FD8C4" />
  </svg>
);

export default CoinsIcon;
